import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss']
})
export class ErrorModalComponent extends NgbActiveModal implements OnInit {
  @Input() public header = "Authorization error";
  @Input() public message;
  projectName = environment.projectName;

  constructor(
    public activeModal: NgbActiveModal
  ) {
    super();
  }

  ngOnInit() {
  }

}
